export const config = {
  API_URL: process.env.REACT_APP_API_URL!,
  DOCUMENT_TEMPLATE_SIGNATURES_URL:
    process.env.REACT_APP_DOCUMENT_TEMPLATE_SIGNATURES_URL,

  DOCUMENT_TEMPLATE_BENEFICIARY_URL:
    process.env.REACT_APP_DOCUMENT_TEMPLATE_BENEFICIARY_URL,
  EMAIL_ONBOARDING: process.env.REACT_APP_EMAIL_ONBOARDING,
  EMAIL_ORDER: process.env.REACT_APP_EMAIL_ORDER,
  EMAIL_MIDDLE_OFFICE: process.env.REACT_APP_EMAIL_MIDDLE_OFFICE,
  WHATSAPP_PHONE: process.env.REACT_APP_WHATSAPP_PHONE,
  PROJECT: (process.env.REACT_APP_PROJECT as 'finance' | 'global') ?? 'finance',

  DOCUMENT_TEMPLATE_FOR_CLIENT_ORDERS_URL:
    process.env.REACT_APP_DOCUMENT_TEMPLATE_FOR_CLIENT_ORDERS_URL,

  IS_DEVELOPMENT: process.env.NODE_ENV === 'development',

  DISABLED_ACCOUNT: process.env.REACT_APP_DISABLED_ACCOUNT === 'true',
};

export const isGlobalProject = () => config.PROJECT === 'global';
export const isFinanceProject = () => config.PROJECT === 'finance';
export const isAccountDisabled = () => config.DISABLED_ACCOUNT;
